import React, { Component } from 'react';
import PropTypes from 'prop-types';

const DEFAULT_HW_CONFIG_ACCOUNT = 'x8AKE7';
const PARTNER_HW_CONFIG_ACCOUNT = 'xMa1Rx';
const ELEMENT_ID = 'headway-updates-widget';

class HeadwayWidget extends Component {
  initWidget = (element) => {
    if (element) {
      const { partnerName } = this.props;
      // eslint-disable-next-line no-undef
      Headway.init({
        selector: `#${ELEMENT_ID}`,
        account:
          partnerName === 'virtualbrokers' || partnerName === 'wealthscope_test'
            ? PARTNER_HW_CONFIG_ACCOUNT
            : DEFAULT_HW_CONFIG_ACCOUNT,
        trigger: '#updates',
      });
    }
  };

  render() {
    return (
      <div
        style={{
          height: '10px',
          display: 'inline-block',
          overflow: 'visible',
          transform: 'translateY(-11px)',
        }}
      >
        <div id={ELEMENT_ID} ref={this.initWidget} />
      </div>
    );
  }
}

HeadwayWidget.propTypes = {
  partnerName: PropTypes.string,
};

HeadwayWidget.defaultProps = {
  partnerName: '',
};

export default HeadwayWidget;
